var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 18,
    viewBox: "0 0 32 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9453 17.3203L1.35156 3.60938C0.765625 3.02344 0.765625 2.08594 1.35156 1.61719L2.17188 0.679688C2.75781 0.210938 3.57812 0.210938 4.16406 0.679688L16 12.75L27.7188 0.796875C28.3047 0.210938 29.125 0.210938 29.7109 0.796875L30.5312 1.61719C31.1172 2.08594 31.1172 3.02344 30.5312 3.60938L16.9375 17.3203C16.3516 17.9062 15.5312 17.9062 14.9453 17.3203Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDown);
export default __webpack_public_path__ + "static/media/angle-down.ea38cadd5a7eee3126743aee906582b9.svg";
export { ForwardRef as ReactComponent };